import { TypedString } from 'types';

type Props = {
  videoId: TypedString<'vimeo-video-id'>;
  autoPlay?: boolean;
};

export function getVimeoVideoSrc({ videoId, autoPlay }: Props): string {
  return `https://player.vimeo.com/video/${videoId}?api=1&autoplay=${
    autoPlay ? 1 : 0
  }`;
}
